<section class="w-full" *ngIf="!isDateInRange">
  <div class="relative overflow-hidden h-auto">
    <video #videoLoopHome loop muted autoplay playsinline class="w-full h-auto">
      <source src="./assets/headerv2.mp4" type="video/mp4" />
    </video>
    <img
      src="./assets/degrade_header_home.png"
      class="overlay-img absolute top-0 w-full h-auto"
    />

    <div class="absolute top-1/3 px-5 md:px-20 sm:pb-5" style="z-index: 10">
      <div class="appearLeft">
        <h1
          class="text-white md:mb-5 mb-1 text-2xl md:text-5xl font-bold drop-shadow-2xl"
        >
          <p class="md:mb-5 leading-tight">Dispensers de agua</p>
          <p class="leading-tight">
            purificada <strong class="text-secondary">para tu hogar.</strong>
          </p>
        </h1>
        <h1 class="text-white md:text-2xl text-sm md:mt-4 mt-2">
          <span class="md:font-bold drop-shadow-lg"
            >Elegí el mejor para vos</span
          >
        </h1>
      </div>
      <a routerLink="/subscription-month" class="inline-block">
        <button
          class="appearAlpha bg-secondary font-bold rounded-full px-6 md:px-12 py-2.5 md:py-3 text-white mt-4 md:mt-8 flex items-center whitespace-nowrap hover:bg-primary shadow-strong hover:shadow-2xl transition-all duration-300 hover:scale-105"
        >
          Suscribite
          <svg
            class="ml-2 w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </button>
      </a>
    </div>
  </div>
</section>
<!-- <section *ngIf="isDateInRange">
  <div class="flex">
    <div>
      <a href="./choose-product?disc=CYBERFIL50"
        ><img
          src="assets/cyberfil/home_50.png"
          alt="Descuento 50%"
          class="opacity-90 transition-opacity duration-300 hover:opacity-100"
      /></a>
    </div>
    <div>
      <a href="./choose-product?disc=CYBERFIL20"
        ><img
          src="assets/cyberfil/home_20.png"
          alt="Descuento 20% x 3 meses"
          class="opacity-90 transition-opacity duration-300 hover:opacity-100"
      /></a>
    </div>
  </div>
</section> -->

<section class="bg-white shadow-soft py-10 md:py-24 px-5 md:px-20">
  <div
    class="grid grid-cols-1 gap-8 md:grid-cols-2 items-center text-center md:text-left max-w-7xl mx-auto"
  >
    <div class="col-span-1 animate-fadeInUp">
      <h1
        class="text-primary font-bold text-3xl md:text-5xl mb-5 md:mr-8 leading-tight"
      >
        ¿Qué incluye <span class="text-secondary">la suscripción?</span>
      </h1>
      <p class="text-gray text-lg mt-4">
        Todo lo que necesitás para disfrutar agua purificada en tu hogar
      </p>
    </div>
    <div
      class="col-span-1 text-center animate-fadeInUp"
      style="animation-delay: 0.2s"
    >
      <div class="grid grid-cols-2 md:grid-cols-3 h-full md:gap-6 gap-3">
        <div class="col-span-1 hover-lift rounded-xl overflow-hidden">
          <img src="assets/b1.png" alt="" class="w-full h-full object-cover" />
        </div>
        <div class="col-span-1 hover-lift rounded-xl overflow-hidden">
          <img src="assets/b2.png" alt="" class="w-full h-full object-cover" />
        </div>
        <div class="col-span-1 hover-lift rounded-xl overflow-hidden">
          <img src="assets/b3.png" alt="" class="w-full h-full object-cover" />
        </div>
        <div class="col-span-1 hover-lift rounded-xl overflow-hidden">
          <img src="assets/b4.png" alt="" class="w-full h-full object-cover" />
        </div>
        <div class="col-span-1 hover-lift rounded-xl overflow-hidden">
          <img src="assets/b5.png" alt="" class="w-full h-full object-cover" />
        </div>
        <div class="col-span-1 hover-lift rounded-xl overflow-hidden">
          <img src="assets/b6.png" alt="" class="w-full h-full object-cover" />
        </div>
      </div>
    </div>
  </div>
</section>

<section
  class="md:hidden flex justify-center items-center shadow-soft overflow-hidden"
>
  <img
    src="assets/pet-mobile.png"
    alt="Imagen cuidamos el planeta"
    class="w-full transition-transform duration-700 hover:scale-105"
  />
</section>

<section
  class="hidden md:flex justify-center items-center shadow-soft overflow-hidden"
>
  <img
    src="assets/pet-pc.png"
    alt="Imagen cuidamos el planeta"
    class="w-full transition-transform duration-700 hover:scale-105"
  />
</section>

<app-landing-subscription-steps></app-landing-subscription-steps>

<!-- <app-landing-opinions></app-landing-opinions> -->
